module.exports = __webpack_public_path__ + "img/birthday-icon.c50c995a.png";